export default __webpack_public_path__ + "static/media/descriptionClouds.86544afc.jpg";